/* src/app/forms/produtos/meli/meli-new-wizard/meli-new-wizard.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.container {
  display: flex;
  height: 100%;
  flex-direction: column;
}
form {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  gap: 10px;
}
.title {
  font-size: var(--tem-fs-lg, 16px);
  font-weight: 500;
}
.step-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  max-width: 640px;
}
.action {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}
.spacer {
  flex: 1;
}
.wizard-divider {
  margin: 4px 0;
}
.step-container-card-product {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 4px;
}
.data-catalogo-item {
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
  position: relative;
}
.container-dados-edit {
  height: 100%;
}
/*# sourceMappingURL=meli-new-wizard.component.css.map */
